export const LOAD_REQUESTED = "ACTIONLIST/LOAD_REQUESTED";
export const LOAD_SUCCESS = "ACTIONLIST/LOAD_SUCCESS";
export const LOAD_FAIL = "ACTIONLIST/LOAD_FAIL";

export default (state = {}, { type }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return {
            ...state, init: true, loading: true, data: [], error: null 
        };
    }
    case LOAD_SUCCESS: {
        return {
            ...state, init: true, loading: false, data, error: null 
        };
    }
    case LOAD_FAIL: {
        return {
            ...state, init: true, loading: false, data: [], error: data 
        };
    }
    default: return state;
    }
};

export const requestLoadactionlist = data => ({ type: LOAD_REQUESTED, data });
export const successLoadactionlist = data => ({ type: LOAD_SUCCESS, data });
export const failLoadactionlist = data => ({ type: LOAD_FAIL, data });
